module.exports = __webpack_public_path__ + "static/media/kissing-face-with-closed-eyes-svgrepo-com.8e4ab0cc.svg";